import { APIConfiguration } from '@savgroup-front-common/configuration';
import {
  COMMON_QUERY_PARAMS,
  SUPPORTED_METHODS,
} from '@savgroup-front-common/constants/shared';
import {
  BackResponseFailure,
  BaseBackResponse,
} from '@savgroup-front-common/types';

import { prepareResponseFailure } from '../../helpers';
import { ApiRequestDescriptor, executeQuery } from '../../services';

const ENDPOINT = `${APIConfiguration.config}sellers/${COMMON_QUERY_PARAMS.SELLER_ID}/configuration/other`;

export interface SetSellerConfigurationOtherCommandArgs {
  sellerId: string;
  cgvUrl?: string | null;
  faqUrl?: string | null;
  lowValueThreshold?: {
    amount: string;
    currency: string;
  } | null;
  automatedMessagesEnabled?: boolean | null;
  isClaimValidationNeeded?: boolean | null;
  defaultOwnerOrderUrl?: string | null;
  ownerNotificationSenderMail?: string;
  paymentUrl?: string;
  qualiReparUrl?: string;
  isCashRegisterConnected: boolean;
  vonageNaming: string;
}

export const setSellerConfigurationOtherRequest = ({
  sellerId,
  ...json
}: SetSellerConfigurationOtherCommandArgs): ApiRequestDescriptor => ({
  url: ENDPOINT.replace(COMMON_QUERY_PARAMS.SELLER_ID, sellerId),
  config: { method: SUPPORTED_METHODS.POST, json },
});

export const setSellerConfigurationOtherCommand = async (
  payload: SetSellerConfigurationOtherCommandArgs,
): Promise<BaseBackResponse | BackResponseFailure> => {
  try {
    return await executeQuery<BaseBackResponse>(
      setSellerConfigurationOtherRequest(payload),
    );
  } catch (error) {
    return prepareResponseFailure(error);
  }
};
